<div class="ontario-row">
  <div class="ontario-column ontario-small-12 ontario-medium-12">
    <div class="uploaded-list" [class.border-top]="!soseApplicationId"  [class.border-bottom]="uploadedDocList.length > 0"
      [class.ontario-margin-bottom-8-!]="uploadedDocList.length > 0" [class.ontario-padding-bottom-8-!]="uploadedDocList.length > 0">
      @for (doc of uploadedDocList; track doc; let i = $index) {
        <div class="ontario-row ontario-padding-top-8-! ">
          <div class="file-row">
            <div class="flex-col-left ontario-column ontario-small-12 ontario-medium-5">
              <div class="icon-div">
                @if (doc.loading) {
                  <mat-spinner aria-label="spinner" [diameter]="20"></mat-spinner>
                }
                @if (doc.loading==false && doc.uploadSuccess) {
                  <img alt="checkmark" src="assets/images/checkmark-green.svg">
                }
                @if (doc.loading==false && !doc.success) {
                  <img alt="cloud upload failed" src="assets/images/fail-cloud.svg">
                }
              </div>
              <span class="name-span">{{doc.fileName}}</span>
            </div>
            <div class="date-column ontario-column ontario-small-12 ontario-medium-7 file-icon-row">
              @if (!doc.loading && doc.uploadSuccess) {
                <div class="success" [class.margined-right]="doc.success && doc.fileSize == 0">
                  {{'FileUpload.UploadedSuccessfully' | translate}}
                </div>
              }
              @if (doc.loading) {
                <div class="progress">{{(doc.progress == 0 ? 'FileUpload.PreparingFile' : 'FileUpload.InProgress') | translate}}</div>
              }
              @if (doc.success && doc.fileSize > 0) {
                <div class="file-total">{{doc.fileSize}} {{doc.unitOfMeasurementString}}</div>
              }
              @if (doc.loading && doc.progress > 0) {
                <div class="file-total">{{doc.progress}} {{doc.unitOfMeasurementString}} {{'General.Of' | translate}} {{doc.fileSize}} {{doc.unitOfMeasurementString}}</div>
              }
              @if (!doc.loading && doc.success) {
                <div class="date-again">
                  {{'FileUpload.UploadedOn' | translate}}
                  {{doc.date | utcToLocalDateTime : 'MMM dd, yyyy'}}
                </div>
              }
              @if (!doc.loading && !doc.success) {
                <div class="error">
                  {{'FileUpload.UploadFailed' | translate}}
                </div>
              }
              @if (doc.downloading) {
                <mat-spinner aria-label="spinner" class="right-marg" [diameter]="20"></mat-spinner>
              }
              @if (displayMode=='Upload' || (doc.subscription && !doc.subscription.closed && doc.progress != doc.fileSize)) {
                <button aria-label="Delete"
                  class="icon-with-circle" [class.delete]="doc.success" [class.cancel]="!doc.success"
                  (click)="removeDocument(doc, i)">
                </button>
              }
              @if ((displayMode=='Download' || displayMode=='UploadNoDelete' || displayMode=='DownloadUpload') && (!doc.subscription || doc.subscription.closed) ) {
                <div>
                  <button aria-label="download" class="icon-with-circle" [class.download]="true" (click)="downloadDocument(doc.metadataId)">
                  </button>
                  @if (displayMode=='DownloadUpload') {
                    <button aria-label="upload"  class="icon-with-circle" [class.upload]="true" [disabled]="disableIfUnderReview" [class.disabled]="disableIfUnderReview"
                    (click)="currentMetadatId = doc.metadataId;currentMetadataName = doc.fileName; fileInput.click()"></button>
                  }
                </div>
              }
            </div>
          </div>
          @if (i < uploadedDocList.length -1) {
            <div class="file-row-seperator"></div>
          }
        </div>
      }
    </div>

    @if (maxFileNumber != null && displayMode=='Upload') {
      <div class="max-files">
        {{'FileUpload.MaxFiles' | translate}}{{maxFileNumber}}
      </div>
    }
    @if (displayMode=='Upload' || displayMode=='UploadNoDelete') {
      <button class="black-button file-upload"
        (click)="currentMetadatId = '';currentMetadataName = '';fileInput.click()"
        [disabled]="maxFileNumber != null && uploadedDocList.length >= maxFileNumber">
        {{'FileUpload.UploadDocument' | translate}}
      </button>
    }

    @if (displayErrors && hasNoFiles(true)) {
      <mat-error class="error-scroll">
        <img alt="warning" src="assets/images/red-warning-triangle.svg">{{'ApplicationForNewTrainingProgram.TPMaterial.PleaseUploadFile' | translate}}
      </mat-error>
    }
    @if (displayMode=='DownloadUpload') {
      <div class="file-row" style="float: right;">
        <div class="upload-new-column ontario-column ontario-small-12 ontario-medium-12 ontario-large-12">
          <a class="link-button" (click)="currentMetadatId = '';currentMetadataName = '';fileInput.click()"
          [class.disabled]="(maxFileNumber != null && uploadedDocList.length >= maxFileNumber) || disableIfUnderReview">{{'FileUpload.UploadNewDocument' | translate}}</a>
        </div>
      </div>
    }
    @if (invalidFile != '') {
      <div class="form-error">
        <mat-error>
          @if (invalidReason == 'type') {
            <span class="type">{{'FileUpload.InvalidFileFormat' | translate}}</span>
          }
          @if (invalidReason == 'size') {
            <span class="size">{{'FileUpload.InvalidSize' | translate}}</span>
          }
          @if (invalidReason == 'name') {
            <span class="name">{{'FileUpload.InvalidDuplicate' | translate}}</span>
          }
        </mat-error>
      </div>
    }

    <input #fileInput [accept]="acceptedFiles"
      type="file" onclick="this.value = null" (change)="chooseFile($event)" class="btn-link screen-reader-only" tabindex="-1">
    </div>
  </div>
